const translation = {
    'login_mfa': 'Ik heb een MFA token',
    'edit': 'Aanpassen',
    'stop_edit': 'Stop aanpassen',
    'destination': 'Bestemming',
    'choose_a_destination': 'Kies een gebied om de doelen naar te verplaatsen',
    'move': 'Verplaats',
    'subjects': 'Leerdoelen | Leerdoel',
    'topics': 'Deelgebieden | Deelgebied',
    'start_typing': 'Beginnen met typen',
    'today': 'Vandaag',
    'yesterday': 'Gisteren',
    'no_date': 'Geen datum',
    'anonymous': 'Anoniem',
    'hide_roster': 'Digitale Klassenmap',
    'download_teacher_error_title': 'Selecteer een school',
    'download_teacher_error_text': 'Selecteer ten minste één school om de leraar gegevens van te downloaden.',
    'teachers_data': 'Download leraargegevens',
    'users': 'Gebruiker | Gebruikers',
    'role': 'Rol | Rollen',
    'system': 'Systeem',
    'reset_password': 'Wachtwoorden instellen',
    'password': 'Wachtwoord',
    'create_new_user': 'Maak een nieuwe gebruiker aan',
    'toStudent': 'Naar {item}',
    'grade': 'Leerjaar',
    'choose_level': 'Kies een klas',
    'choose_period': 'Kies een semester',
    'global_user': {
        role: 'Global User | Global Users',
    },
    'navigation': {
        scoolcore: 'MijnBasis',
        scooladmin: 'MijnInstellingen',
        roster: 'MijnRooster',
    },
    'trashed': {
        title: 'Verwijderde leerdoelen',
    },
    'Show inactive items': 'Toon ook verwijderde leerdoelen',
    'Only show active items': 'Toon alleen actieve leerdoelen',
    'students': {
        tab: {
            school_tracker_description: 'Stukje tekst over Mijn PLP',
            this_is_me_description: 'Stukje tekst over Persoonlijk',
            portfolio_description: 'Stukje tekst over Mijn Drive',
            levels_description: 'Stukje tekst over Niveaus',
            profile_description: 'Stukje tekst over Profiel',
            messages_description: 'Stukje tekst over Berichten',
            notes_description: 'Stukje tekst over Notities',
            treatment_description: 'Stukje tekst over opmerkingen voor getuigschrift',
            lvs_description: 'Stukje tekst over LVS',
            finished_description: 'Stukje tekst over Successen',
            roster_description: 'Stukje tekst over Mijn Rooster',
            plan: 'Stukje tekst over plannen',
        },
    },
    'deleted': 'Verwijderd',
    'delete': 'Verwijderen',
    'report': {
        no_areas: 'Er zijn geen Hoofdgebied gemaakt',
        no_areas_subtext: 'Je kunt naar Curriculum > Nieuw Hoofdgebied gaan om er een te maken.',
        target: 'Uitstroom',
        reference_level: 'Waarde (niveauwaarde, percentielscore etc.)',
        period: 'Toets',
        date: 'Datum',
        score: 'LVS score (I t/m V of A t/m E)',
        choose_filter: 'Pas de bovenstaande filters eerst toe om informatie weer te geven.',
        headers: {
            group: 'Klas',
            lvs: 'Analyse',
        },
        sub_headers: {
            prev_period: 'Vorige Toets',
            curr_period: 'Huidige Toets',
            notes: 'Notities',
            target: 'Uitstroom / Ambitie',
        },
    },
    'auth': {
        login: 'Inloggen',
        set_mfa_page: 'MFA instellen',
        invalid: 'De combinatie van gebruikersnaam en wachtwoord is niet bekend. Probeer het nog een keer.',
        logout: 'Uitloggen',
        forgot: {
            title: 'Wachtwoord vergeten',
            instruction: 'Ouders en leerkrachten kunnen hier een nieuw wachtwoord opvragen. Voer je e-mailadres in en ontvang een mail om een nieuw wachtwoord aan te maken. Leerlingen kunnen zich melden bij de leraar.',
            submit: 'Zoeken',
            contact: 'Neem contact op met je schoolbeheerder om je wachtwoord opnieuw in te stellen.',
            login: 'Nog geen login? Klik hier',
        },
        reset: {
            title: 'Wachtwoord resetten',
            instruction: 'Maak een nieuw wachtwoord aan',
            submit: 'reset',
        },
        submitted: {
            success: 'Gelukt!',
            sent: 'We hebben een mail gestuurd aan {email}.',
            again: 'Log opnieuw in',
        },
        password: 'wachtwoord',
        confirm_password: 'Bevestig wachtwoord',
        no_match: 'De wachtwoorden komen niet overeen',
        required: 'Wachtwoord is verplicht',
        mfa: 'MFA Token',
        mfa_title: 'Multi-factor authentication instellen',
    },
    'goalsetSelect': {
        title: 'Toon periodeplannen',
        showGoalsetOnly: 'Doelen uit periodeplannen',
        showAll: 'Alle doelen',
        showStudentGoalsOnly: 'Doelen gekoppeld aan leerlingen',
    },
    'dashboard': {
        title: 'MijnDashboard',
        welcome: 'Welkom {name}',
        intro: 'Wat leuk dat je er weer bent.',
        finished: 'Dit kwartaal behaalde {item}',
    },
    'roster': {
        title: 'Schoolrooster',
        planner: 'MijnRooster instellingen',
        preplanner: 'Preplanner',
        preplannerExplanation: 'De pre-planner zal alle leerlingen met 1 verplichte les of maar 1 keuze les per tijdslot automatisch inplannen voor die les voor de opgegeven periode. Indien een leerling door de pre-planner is ingepland op een les, kan dat niet meer door een nieuwe pre-planner taak ongedaan worden gemaakt. Wil je dit wel ongedaan maken, zul je eerst de pre-run moeten draaien voordat je de pre-planner opnieuw uitvoert.',
        autoplanner: 'Autoplanner',
        attention: 'LET OP!',
        prerun: 'Prerun',
        preRunExplanation: 'Met de pre-run reset je de opgegeven periode. Dat wil zeggen dat alle eventuele reeds gemaakte keuzes van leerlingen worden verwijderd. Op basis van de instellingen en doelen per les, wordt vervolgens bepaald welke leerlingen voor welke lessen worden uitgenodigd.',
        start: 'Start',
        clickHere: 'Klik hier',
        runTime: 'Het duurt minimaal 30 minuten tot de autoplanner voltooid is.',
        autoplannerExplanation: 'Op dit tijdstip wordt voor alle leerlingen het rooster automatisch afgemaakt. Voor alle lessen waar nog geen keuze is gemaakt door de leerling, maakt de computer die.',
        autoplannerExplanation_2: 'De autoplanner probeert voor alle leerlingen die nog een keus hebben een keus te maken. De autoplanner houdt rekening met een aantal regels (zoals de capaciteit van een lokaal). Het kan dus voorkomen dat niet alle leerlingen aan een les gekoppeld kunnen worden.',
        softLock: 'Soft-lock',
        softLockExplanation: 'Alleen de lestijden van alle lessen vóór en op deze datum kunnen niet meer worden aangepast. De inhoud van de lessen kan door leraren wél nog worden aangepast. Leerlingen kunnen wél lessen kiezen.',
        hardLock: 'Hard-lock',
        hardLockLockExplanation: 'De lesinhoud en lestijden van alle lessen vóór en op deze datum kunnen niet meer worden aangepast. Leerlingen kunnen ook geen lessen meer kiezen.',
        visibleTeacher: 'Zichtbaarheid Leraar',
        visibleTeacherExplanation: 'Alle lessen vóór en op deze datum zijn zichtbaar voor de leraar. Alle lessen ná deze datum zijn niet zichtbaar voor de leraar.',
        visibleStudent: 'Zichtbaarheid Leerling',
        visibleStudentExplanation: 'Alle lessen vóór en op deze datum zijn zichtbaar voor de leerling. Alle lessen ná deze datum zijn niet zichtbaar voor de leerling.',
        autoPlannerWeekInterval: 'Auto planner week interval',
        autoPlannerWeekIntervalExplanation: 'Stel hier in hoeveel weken de Autoplanner vooruit moet inplannen. Standaard is dit 1 week.',
        release_teacher: 'Vrijgeven aan leraren',
        release_teacherExplanation: 'Op dit tijdstip wordt het rooster automatisch vrijgegeven aan de leraren zodat zij de doelen kunnen koppelen aan de lessen. De roosterbeheerder kan vanaf dit moment de lestijden niet meer aanpassen.',
        release_student: 'Vrijgeven aan leerlingen',
        release_studentExplanation: 'Op dit tijdstip wordt het rooster automatisch vrijgegeven aan de leerlingen zodat zij keuzes kunnen maken voor lessen.',
        blockPlanner: 'Keuzes blokkeren',
        blockPlannerExplanation: 'Op dit tijdstip wordt het rooster automatisch dichtgezet voor leerlingen. Zij kunnen geen keus meer maken.',
        finalRoster: 'Rooster definitief',
        finalRosterExplanation: 'Op dit tijdstip wordt het rooster definitief gemaakt. Vanaf dit tijdstip kunnen de lestijden en lesinhoud niet meer worden aangepast. Leerlingen kunnen ook geen lessen meer kiezen.',
        settings: 'Rooster instellingen',
        settingsWeek: 'Weekinstellingen rooster',
        settingsGeneral: 'Huidige roosterwaarden',
        myRoster: 'Rooster',
        myLessons: 'Mijn lessen',
        hours: 'Vaste werktijden',
        workHours: 'Werktijden',
        calendar: 'Afwezigheid per week',
        dialog: {
            subjects: 'Leerdoel(en)',
            lessonType: 'Lestype',
            overview: 'Overzicht',
            select: 'Selecteer',
            addComment: 'Laat een notitie voor de leerlingen achter in het rooster',
            lessonMandatory: 'Les overzicht',
            amountOfStudents: 'Aantal leerlingen',
            invite: 'Keuze',
            invited: 'Keuze',
            mandatoried: 'Verplicht',
            mandatory: 'Leerlingen & doelen overzicht',
            is_default: 'Les voorwaarden',
            notMandatoried: 'Keuze',
            mandatoryErrorTitle: 'Les kan niet worden gekozen',
            mandatoryErrorMessage: 'Je kunt die keuze niet maken, omdat je op dat moment al een verplichte les (gekozen) hebt.',
            sameLevelNotFinished: 'Zit in deze les en heeft het leerdoel nog actief',
            sameLevelFinished: 'Zit in deze les en heeft het leerdoel al behaald',
            notSameLevelPLP: 'Zit niet in deze les maar heeft het leerdoel wel actief',
            others: 'Zit niet in deze les',
            selectOtherStudents: 'Nodig andere leerlingen uit',
            lessonOverview: 'Les overzicht',
            description: 'Omschrijving',
            mandatoryAndInvitation: 'Verplicht en keuze',
            edit: 'Pas les aan',
            noSubjects: 'Geen leerdoel(en) geselecteerd',
            noLessonType: 'Geen lestype geselecteerd',
            inviteExtra: 'Andere leerlingen uitnodigen',
        },
        activities: 'activiteit | activiteiten',
        lessons: 'les | lessen',
        information: {
            title: 'Rooster informatie',
            red: 'Deze les is niet meer aan te passen.',
            blue: 'Hier is geen keuze.',
            orange: 'Er is nog geen les gekozen.',
            green: 'Een les is gekozen.',
        },
    },
    'tool': {
        title: 'MijnRooster',
        buttons: {
            subject: 'Doelen overzicht',
            presence: 'Aanwezigheid',
            students: 'Leerlingen',
            edit_class: 'Les bewerken',
        },
        alert: {
            text: 'Er zijn geen lessen gevonden voor de geselecteerde dag.',
            subtext: '',
        },
        search: 'Zoek een ander rooster',
        sync: {
            message: 'Klik op de knop om voor iedereen zijn laatste rooster op te halen.',
            in_progress: 'Op dit moment wordt er een opdracht uitgevoerd. Zodra deze klaar is kunt u weer synchroniseren',
            warning: 'Het kan 5 minuten duren voordat iedereen zijn nieuwe rooster ziet',
            button: 'Sync MijnRooster',
        },
    },
    'notifications': {
        title: 'MijnBerichten',
        title_overview: 'MijnBerichten geschiedenis',
        today: 'Vandaag',
        alert: {
            text: 'Geen berichten',
            subtext: 'Je hebt nog geen berichten ontvangen.',
        },
        delete: 'Markeer selectie als gelezen',
        delete_all: 'Markeer alles als gelezen',
        message: {
            content: 'heeft een bericht geplaatst op',
            at: 'op',
        },
        view_all: 'Bekijk alle berichten',
        tabs: {
            chat: 'Leerling pagina',
            plp: '   pop-up',
            group: 'Klassen-chats',
            subject: 'Leerdoelen',
            new_chat: 'Nieuwe berichten',
        },
        finished: {
            title: 'Leerdoel behaald!',
        },
    },
    'scoollinks': {
        title: 'MijnFavorieten',
        alert: {
            text: 'Geen MijnFavorieten',
            subtext: 'Je hebt nog geen MijnFavorieten aangemaakt.',
        },
        dialog: {
            create: {
                title: 'MijnFavorieten aanmaken',
                subtitle: 'MijnFavorieten aanmaken',
                submitting: 'MijnFavorieten wordt opgeslagen',
                submitted: 'MijnFavorieten is aangemaakt',
            },
            edit: {
                title: 'MijnFavorieten aanpassen',
                subtitle: 'MijnFavorieten aanpassen',
                submitting: 'MijnFavorieten wordt opgeslagen',
                submitted: 'MijnFavorieten is aangepast',
            },
            delete: {
                title: 'MijnFavorieten verwijderen',
                subtitle: 'MijnFavorieten verwijderen',
                text: 'Weet je zeker dat je dit wilt verwijderen?',
            },
        },
    },
    'back': 'Terug',
    'search': 'Zoeken',
    'avatar': {
        title: 'Profielfoto',
        change: 'Wijzig foto',
    },
    'name': {
        title: 'Naam',
        first: 'Voornaam',
        middle: 'Tussenvoegsel',
        last: 'Achternaam',
    },
    'age': {
        title: 'Leeftijd',
    },
    'profile': {
        parnassys: {
            title: 'Parnassys',
            placeholder: 'Enter parnassys id',
            label: 'Parnassys ID',
        },
        title: 'Leerlingkaart',
        setting: 'Instelling',
        mine: 'Mijn Profiel',
        standard: 'Standaard Informatie',
        contact: {
            information: 'Contact Informatie',
            person: 'Contactpersoon',
            number: 'Contactnummer',
        },
        tag: {
            information: 'Type Leerling',
        },
        extra: 'Medische Informatie',
        dob: 'Geboortedatum',
        guardians: 'Ouders/Verzorgers',
        students: 'Leerlingen',
        email: 'Email',
        phone: 'Telefoon',
        allergy: 'Allergie | Allergieën',
        medicine: 'Medicijn | Medicijnen',
        password: {
            title: 'Nieuw wachtwoord',
            forgot: 'Wachtwoord vergeten?',
            confirm: 'Bevestig wachtwoord',
            change: 'Verander wachtwoord',
        },
        group: 'Klas',
        groups: 'Klassen',
        login: 'Login als',
        level: {
            title: 'Niveau',
            information: 'Niveau informatie',
        },
        finished: {
            title: 'Successen',
        },
        parnassys_group: 'Parnassysgroep',
        coach: 'Kleuterklas',
        room: 'Lokaal',
        class: 'Klas',
        url: 'Url',
        language: 'Taal',
        type: 'Type',
        address: 'Adres',
        street: 'Straat',
        housenumber: 'Huisnummer',
        addition: 'Toevoeging',
        zipcode: 'Postcode',
        city: 'Plaats',
        rotateImage: 'Roteer geselecteerd afbeelding',
        project: 'Periodeplan*',
        my_subject_overview: 'Naar mijn doelen overzicht',
        add_support: 'Voeg opmerkingen voor getuigschrift toe',
    },
    'library': {
        title: 'Bibliotheek',
    },
    'curricula': {
        title: 'Alle curricula',
        add: 'Voeg curriculum toe',
        form: {
            upload: 'Klik hier om een curriculum te uploaden',
            uploading: 'We zijn druk bezig het curriculum te uploaden....',
            problem: 'Er is een fout geconstateerd',
            hint: {
                p1: 'Om een curriculum te uploaden moet hij in een vast format zijn, Download deze hier:',
                p2: '',
            },
            redirect: 'Zodra je curriculum "{name}" geupload is, wordt hij geopend',
            moment: 'Nog even wachten...',
            error: 'Het uploaden van je curriculum duurt iets langer als normaal, we kijken of er iets fout kan zijn gegaan.',
            support: 'Probeer het nog een keer, als het weer niet lukt maak dan een Helpdesk ticket aan.',
        },
        searchDialog: {
            title: 'Leerdoel zoeken',
            placeholder: 'Zoek leerdoel',
            selected_title: 'Geselecteerde leerdoelen',
            headers: {
                area: 'Hoofdgebied',
                subject: 'Leerdoel',
                level: 'Niveau',
                period: 'Kwartaal',
                actions: 'Acties',
            },
            actions: {
                apply: 'Toepassen',
            },
        },
    },
    'curriculum': {
        title: 'Curriculumoverzicht',
        import: {
            area: {
                title: 'Importeer Hoofdgebied/Deelgebied en Leerdoelen',
                header: 'Nieuw hoofdgebied | Nieuw hoofdgebieden',
                success: 'Het nieuwe hoofdgebied is aan je curriculum toegevoegd',
            },
            topic: {
                title: 'Importeer Deelgebied en Leerdoelen voor een specifiek Hoofdgebied',
                header: 'Importeer Deelgebied |  Importeer Deelgebieden',
                success: 'Het nieuwe deelgebied is aan je curriculum toegevoegd',
            },
            subject: {
                title: 'Importeer Leerdoelen voor een specifiek Deelgebied',
                header: 'Importeer Leerdoelen |  Importeer Leerdoelen',
                success: 'De nieuwe doelen zijn aan je curriculum toegevoegd',
            },
        },
        area: {
            exclude: {
                button: 'Niet meenemen in PLP',
                message: 'Weet u zeker dat u dit gebied wilt uitsluiten van de automatisch gegenereerde PLP\'s?',
            },
            include: {
                button: 'Meenemen in PLP',
                message: 'Weet u zeker dat u dit gebied wilt opnemen in de automatisch gegenereerde PLP\'s?',
            },
            periodChange: {
                button: 'Negeren bij kwartaal wissel',
                ignoreStatus: {
                    title: 'Status van doelen niet aanpassen bij kwartaal wissel',
                    button: 'Ja, status niet aanpassen',
                    message: 'Bij een kwartaal wissel worden de statussen van de doelen van dit hoofdgebied niet aangepast / genegeerd. Weet u het zeker?',
                },
                updateStatus: {
                    title: 'Status van doelen aanpassen bij kwartaal wissel',
                    button: 'Ja, status aanpassen',
                    message: 'Bij een kwartaal wissel worden de statussen van de doelen van dit hoofdgebied aangepast. Weet u het zeker?',
                },
            },
            enableWorksheet: {
                button: 'Genereerbaar werkblad',
                message: 'Geeft gebruikers de optie om een werkblad te genereren.',
                cancel: 'annuleren',
                enable: 'Werkblad generatie inschakelen',
                disable: 'Werkblad generatie uitschakelen',
            },
        },
        topic: {
            add: 'Voeg een deelgebied toe',
        },
        subject: {
            add: 'Voeg leerdoelen toe',
            rating: 'Starts',
        },
        newSubject: {
            title: 'Maak een nieuw',
            select: {
                areaColor: 'Selecteer de kleur van je nieuwe hoofdgebied',
                areaIcon: 'Selecteer een icoon voor het nieuwe hoofdgebied',
            },
            placeholder: 'Maak een {item} aan',
            create: 'Opslaan',
            selectFilter: {
                level: 'Kies een niveau',
                period: 'Kies een kwartaal',
            },
        },
        alert: {
            text: 'Dit curriculum heeft nog geen Hoofdgebieden.',
            subtext: 'Je kan een Hoofdgebied toevoegen door op de knop te drukken.',
        },
        total: {
            getAll: 'Totale is opgehaald',
        },
    },
    'mfa': {
        remove: {
            title: 'Multi-factor authenticatie',
            descriptionTrue: 'Druk op de knop om de MFA opnieuw in te kunnen stellen.',
            descriptionFalse: 'Deze gebruiker heeft geen MFA ingesteld.',
            button: 'Reset MFA',
        },
        dialog: {
            remove: {
                title: 'MFA resetten',
                text: 'Weet je zeker dat je de MFA voor {name} wilt resetten?',
            },
        },
    },
    'user': {
        add: '{item} toevoegen',
        deleted_students: 'Verwijderde leerlingen tonen',
        all_students: 'Alle leerlingen tonen',
        restore: 'Leerling herstellen',
    },
    'level': {
        title: 'Niveau | Niveaus',
        title2: 'MijnLeerlijn',
        create: 'Nieuw niveau aanmaken',
        placeholder: {
            name: 'Niveau naam',
            value: 'Niveau waarde',
            sequence: 'Niveau sequence',
        },
    },
    'subject_label': {
        all: 'Alle Leerdoel tags',
        add: '{item} toevoegen',
        title: 'Leerdoel tag | Leerdoel tags',
        title2: 'Leerdoel tag | Leerdoel tags',
        create: 'Nieuwe Leerdoel tag aanmaken',
        placeholder: {
            name: 'Leerdoel tag naam',
        },
    },
    'period': {
        title: 'Kwartaal | Kwartalen',
        create: 'Nieuw kwartaal aanmaken',
        add: '{item} toevoegen',
        information: 'Kwartaal informatie',
        placeholder: {
            name: 'Kwartaal naam',
            value: 'Kwartaal waarde',
        },
    },
    'group': {
        title: 'MijnKlas | MijnKlassen',
        all: 'Alle Klassen',
        mine: 'Mijn Klassen',
        student: 'Leerling | Leerlingen',
        teacher: 'Leraar | Leraren',
        guardian: 'Ouder | Ouders',
        projectPlan: 'PeriodePlan',
        type: 'Klastype | Klasypes',
        amountOfStudents: 'Aantal leerlingen',
        idpGroup: 'PLP Overzicht',
        profile_title: 'Klassen informatie',
        report: 'Analyse',
        deleted_groups: 'Verwijderde klassen tonen',
        all_groups: 'Alle klassen tonen',
        restore: 'Klas herstellen',
        types: {
            fixed: 'Klas voor rooster',
            class: 'Klas',
            coach: 'Kleuterklas',
            project: 'Klas voor projecten',
            parnassys: 'Parnassys',
        },
        add: '{item} toevoegen',
        dialog: {
            select: 'Selecteer een {type} die je aan deze klas wilt toevoegen.',
            selected: 'Geselecteerde',
        },
        select: 'Selecteer een klas type',
        placeholder: 'Kies klas',
        addSubject: {
            choose: 'Kies leerdoel(en)',
            chooseSubText: 'Kies leerdoel(en) om toe te voegen aan de klas',
            confirm: 'Bevestig de leerdoel(en) voor de klas',
            confirmSubText: 'Wil je deze leedoel(en) aan de klas toevoegen?',
            created: 'Je hebt nieuwe leerdoelen aan de klas toegevoegd',
        },
        errors: {
            noStudents: {
                description: 'De huidige klas bevat nog geen leerlingen met doelen.',
                suggestion: 'Voeg een paar leerdoelen toe aan leerlingen in deze klas, of maak een andere selectie.',
            },
        },
        newFromStudents: {
            add: 'Nieuwe klas aanmaken',
        },
    },
    'documents': {
        title: 'MijnDocumenten',
        label: 'Document | Documenten',
        name: 'Document naam',
        connection: "Groep of leerling",
        object_info: {
            user: 'Leerling',
            group: 'Groep',
        },
        connectionName: "Naam groep of leerling",
        selectPlaceholder: 'Kies groep of leerling',
        group: 'Groep',
        student: 'Leerling',
    },
    'year': {
        title: 'Jaar | Jaren',
        all: 'Alle Jaren',
        create: 'Nieuw schooljaar aanmaken',
        starts: 'Start',
        ends: 'Eind',
        value: 'Waarde',
        noCurriculum: '',
        active: 'Actief',
        inactive: 'Inactief',
        information: 'Jaar informatie',
        add: '{item} toevoegen',
    },
    'tag': {
        title: 'School | Scholen',
        all: 'Alle Scholen',
        add: '{item} toevoegen',
        create: 'Nieuwe school toevoegen',
        placeholder: 'Selecteer school',
    },
    'room': {
        title: 'Lokaal | Lokalen',
        all: 'Alle Lokalen',
        add: 'Add room',
        placeholder: 'Selecteer lokaal',
        maxCapacity: 'Maximum capaciteit',
        color: 'Kleur',
        lessonTypes: 'Les types',
        addLessonType: 'Voeg les type toe',
        levels: 'Niveaus',
        addLevels: 'Voeg niveau toe',
        dialog: {
            create: 'Voeg een lokaal toe',
            edit: 'Wijzig lokaal',
            type: 'Les type',
            capacity: 'Capaciteit',
            color: 'Selecteer een kleur voor het nieuwe lokaal',
            editColor: 'Wijzig de kleur van het lokaal',
        },
        button: {
            add: 'Toevoegen',
            edit: 'Wijzigen',
        },
    },
    'lessonType': {
        title: 'Les type | Les types',
        all: 'Alle les types',
        button: {
            add: 'Voeg toe',
            edit: 'Pas aan',
        },
        dialog: {
            add: 'Les type',
            edit: 'Pas les type aan',
            icon: 'Les type icoon',
        },
    },
    'school_tools': {
        parnassys: {
            sync_teachers_button: 'Leraren Synchroniseren',
            sync_parents_button: 'Synchroniseer Ouders',
            sync_students_button: 'Studenten Synchroniseren',
            sync_message_warn: 'Let op: het brinnummer van Parnassys dient ingevuld te zijn in Mijn School -> Instellingen.',
            sync_message: 'Klik op de knop om de leerling, leraar en groepinformatie te synchroniseren met de data van Parnassys.',
            title: 'Synchroniseer met Parnassys',
        },
    },
    'school': {
        title: 'Klant | Klanten',
        myschool: 'School instellingen',
        hide_roster: 'Digitale Klassenmap',
        tools: 'Tools',
        roster: 'MijnRooster instellingen',
        settings: 'Instellingen',
        lvs_settings: 'Analyse Instellingen',
        group_settings: 'Klas Instellingen',
        logbook: 'Logboek',
        parnassys_title: 'Parnassys',
        mfa_title: 'MFA',
        holiday: 'Vakanties',
        templates: 'Week sjablonen',
        management: 'Schoolrooster',
        openingHours: 'Openingstijden',
        select: 'Selecteer een klant',
        all: 'Alle Klanten',
        add: '{item} toevoegen',
        version: 'Versie',
        mail_settings: 'Email instellingen',
        create: {
            title: 'Maak een nieuwe:{role}',
            description: 'Maak een nieuwe {role} aan met zijn eigen omgeving.',
            logo: {
                title: '{role} logo',
                small: '{role} logo (klein)',
            },
            address: {
                title: 'Extra gegevens',
                text: 'Vul hier het adres in en contact gegevens',
                address: 'Adres gegevens',
                street: 'Straat',
                number: 'Nummer',
                add: 'Toevoeging',
                zipcode: 'Postcode',
                city: 'Stad',
                contact: 'Contact gegevens',
            },
            confirm: {
                title: 'Bevestig de gegevens',
                text: 'Bevestig of alle gegevens juist zijn van de nieuwe {role}.',
                school: 'Klant gegevens',
                locales: {
                    title: 'Land',
                    nl: 'Nederland',
                },
                languages: {
                    title: 'Taal',
                    nl: 'Nederlands',
                    en: 'Engels',
                    vo: 'Vrije school',
                },
                address: 'Adres gegevens',
                contact: 'Contact gegevens',
            },
            finished: {
                title: '{role} aangemaakt',
                description: 'Wij hebben jouw nieuwe {role} aangemaakt.<br>Je kan inloggen met de gegevens beneden.<br>De school is beschikbaar met de URL voor jouw omgeving.',
            },
        },
        lvs_setting: {
            areas_title: 'Hoofdgebieden',
            periods_title: 'Analyse Moment',
            period_create_title: 'Nieuw kwartaal aanmaken',
            period_level_placeholder: 'Voer een niveau in tussen 1 en 8',
        },
        placeholder: 'Selecteer school type',
    },
    'rosterTemplate': {
        title: 'Week sjabloon | Week sjablonen',
        add: 'Voeg week toe',
        save: 'Sla week op',
        createdAt: 'Aangemaakt op',
        updatedAt: 'Gewijzigd op',
        start: 'Start van de week',
        dialog: {
            header: {
                activities: 'Les | Lessen',
                teachers: 'Leraren',
                areas: 'Hoofdgebieden',
                area: 'Hoofdgebied',
                topics: 'Deelgebieden',
                rooms: 'Lokalen',
                levels: 'Niveaus en vaste klassen',
                overview: 'Overzicht',
                finished: 'Finished',
            },
            activities: 'Tijdslot overzicht',
            teachers: 'Selecteer een leraar',
            areas: 'Selecteer een hoofdgebied',
            selectedArea: 'Geselecteerde hoofdgebied',
            topics: 'Selecteer een deelgebied',
            allTopics: 'Alle deelgebieden',
            rooms: 'Selecteer een lokaal',
            levelAndGroup: 'Selecteer niveaus en/of klassen',
            level: 'Selecteer een niveau',
            overview: 'Overzicht',
            addActivity: 'Voeg een les toe',
            addBreak: 'Voeg een pauze toe',
            remove: 'Verwijder gehele tijdslot',
            create: 'Maak een les aan',
            teacherMessage: 'Bij het aanmaken van een les kun je alleen een leraar selecteren waarvoor nog geen les is ingepland.',
            roomMessage: 'Bij het aanmaken van een les kun je alleen een lokaal selecteren waarvoor nog geen les is ingepland.',
            mandatoryMessage: 'Verplichte niveaus en klassen zijn rood gekleurd.',
            roomFullMessage: 'De geselecteerde level/klas heeft te veel studenten om in het lokaal te passen | De geselecteerde levels/groepen hebben te veel studenten om in het lokaal te passen',
            doublePeriodMessage: 'Blokuren hebben een blauw streep naast de les regel.',
            message: '',
            mandatory: {
                levels: {
                    checkbox: 'Maak verplicht voor alle bovenstaande niveaus',
                    overview: 'Deze niveaus zijn verplicht',
                },
                groups: {
                    checkbox: 'Maak verplicht voor alle bovenstaande klassen',
                    overview: 'Deze klassen zijn verplicht',
                },
            },
            created: 'Les is gemaakt',
            updated: 'Les is aangepast',
            createTimeslot: 'Maak een nieuw tijdslot',
            timeslotTitle: 'Tijdslot titel',
            startsAt: 'Begint met',
            endsAt: 'Eindigt met',
            doublePeriod: 'Blok uur',
            doublePeriodLabel: 'Maak van deze les een blokuur',
            selectDoublePeriod: 'Selecteer tot welk tijdstip dit blokuur moet lopen',
        },
        recess: 'Pauze',
    },
    'rosterManagement': {
        title: 'Rooster Management',
        buttons: {
            create: 'Rooster maken',
            release: 'Vrijgeven',
            unsafeMode: 'Schakel de onveilige modus in',
            safeMode: 'Schakel de veilige modus in',
            warning: 'waarschuwing | waarschuwingen',
            error: 'fout | fouten',
            studentsWithoutLessons: 'Leerlingen zonder les',
        },
        filter: {
            choose: 'Kies {type}',
        },
        unsafeMode: 'U zit in de onveilige modus',
        roster: 'Schoolrooster',
        today: 'Vandaag',
        dialog: {
            header: {
                selectDate: 'Selecteer startdatum en dan de duur van het rooster',
                assignRoster: 'Weken toewijzen',
                overview: 'Overzicht',
                success: 'Succes',
                studentsWithoutLessons: 'Leerlingen zonder les',
            },
            startDate: 'Start datum',
            amountOfWeeks: 'Aantal weken:',
            generating: 'Er wordt een rooster gegenereerd, dit kan een minuutje duren ...',
            generated: 'Gelukt, het rooster is gegenereerd',
            releaseRoster: 'Rooster vrijgeven',
            visibleForTeachers: 'Zichtbaar voor leraren',
            visibleForStudents: 'Zichtbaar voor leerlingen',
            softLock: 'Soft lock',
            hardLock: 'Hard lock',
        },
    },
    'time': {
        title: 'Tijd',
        start: 'Start tijd',
        end: 'Eind tijd',
        slot: 'Tijdslot',
        day: 'Dag',
    },
    'event': {
        title: 'Lessen',
        dialog: {
            create: 'Maak een nieuwe afspraak aan',
            edit: 'Pas afspraak aan',
            remove: 'Verwijder afspraak',
            choose: 'Kies een les',
            overview: 'Les overzicht',
            studentOverview: 'Studenten overzicht',
            subjectOverview: 'Doelen overzicht',
            title: 'Afspraak titel',
            recurring: 'Terugkerend afspraak',
            frequency: 'Kies',
            daily: 'Dagelijks',
            weekly: 'Wekelijks',
            monthly: 'Maandelijks',
            doublePeriod: 'Let op! Deze les is een blokuur.',
            noSubjectsSelected: 'Je hebt geen doelen geselecteerd bij stap 1.',
            noLessonTypeSelected: 'Je hebt geen lestype geselecteerd bij stap 2.',
            noDescription: 'Je hebt geen omschrijving toegevoegd bij stap 2.',
        },
        edit: {
            busyWithSameLevelOrGroup: 'Zit in deze les en heeft het leerdoel nog actief',
            completedWithSameLevelOrGroup: 'Zit in deze les en heeft het leerdoel al behaald',
            notSameLevelOrGroup: 'Zit niet in deze les maar heeft het leerdoel wel actief',
            notInPlp: 'Zit niet in PLP',
            totalUnique: 'Totaal unieke leerlingen',
            makeChoice: 'Maak tot keuze',
            visibleStudents: 'Deze les is al zichtbaar voor leerlingen en kan daarom niet meer worden aangepast.',
            hardlocked: 'Deze les bevindt zich voor of op de hard-lock datum en kan daarom niet meer worden aangepast.',
        },
        goToThisLesson: 'Ik wil naar deze les',
        lessonFull: 'Deze les is vol',
        chosenLesson: 'Ik heb deze les gekozen',
        total: 'Totaal uitgenodigde leerlingen',
        godmode: 'Kies uit alle lessen',
        godmodeOff: 'Terug naar het scherm van de leerling',
        godmodeChosen: 'Deze les is gekozen voor de leerling.',
    },
    'weekDays': {
        monday: 'maandag',
        tuesday: 'dinsdag',
        wednesday: 'woensdag',
        thursday: 'donderdag',
        friday: 'vrijdag',
        saturday: 'zaterdag',
        sunday: 'zondag',
    },
    'holiday': {
        title: 'Vakantie  | Vakanties',
        dialog: {
            title: 'Voeg een vakantie toe',
        },
        button: {
            add: 'Voeg toe',
            edit: 'Pas aan',
        },
    },
    'openingHours': {
        title: 'Schooltijden',
        startOfTheWeek: 'Begin van de week',
        plannerStart: 'Start planner',
        noTime: 'Geen tijd geselecteerd',
        noDay: 'Geen dag geselecteerd',
        selectedDay: 'Selecteer dag',
    },
    'area': {
        description: 'Hoofdgebied omschrijving',
        name: 'Hoofdgebied naam',
    },
    'subject': {
        title: 'Leerdoel | Leerdoelen',
        description: 'Omschrijving',
        rating: 'Sterren',
        deleted: 'een verwijderd doel',
        summary: {
            title: 'Overzicht Leerdoelen',
            chooseLevel: 'Stel bovenstaand filter eerst in, om het gekozen leerdoelen overzicht te zien.',
            noSubjects: 'Geen doelen gevonden.',
        },
        area: {
            title: 'Hoofdgebied | Hoofdgebieden',
        },
        topic: {
            title: 'Deelgebied | Deelgebieden',
        },
        dialog: {
            finishedNote: {
                placeholder: 'Leg uit hoe het doel behaald is.',
                warning: '*Attachments kunnen niet geupload worden naar de doelen die momenteel inactief zijn. Indien je inactieve doelen hebt geselecteerd moet je eerst de status van de doelen aanpassen.',
            },
            generalNote: {
                placeholder: 'Notitie',
            },
            achievedNote: {
                title: 'Stappen',
                placeholder: 'Leg uit wat voor de leerling de volgende stap is.',
            },
            addSubject: {
                title: 'Voeg leerdoel(en) toe',
                select: {
                    area: 'Selecteer hoofdgebied',
                    topic: 'Selecteer deelgebied',
                    goal: 'Selecteer leerdoel',
                    file: 'Selecteer bestand',
                    placeholder: 'Selecteer',
                },
                notFound: {
                    topic: 'Geen deelgebied gevonden',
                    goal: 'Geen leerdoel gevonden',
                },
                mode: 'Omgeving',
                status: 'Status',
                description: 'Omschrijving',
                upload: 'Uploaden',
                addedTo: 'Toegevoegd in',
            },
        },
        schedule: {
            title: 'Aanwezigheid',
            present: 'Aanwezig',
            absent: 'Afwezig',
            tardy: 'Te laat',
            sick: 'Ziek',
            approvedAbsence: 'Geoorloofd afwezig',
        },
        tab: {
            content: 'Inhoud',
            notes: 'Notities',
            template: 'Stappen',
            files: 'Bestanden',
            messenger: 'MijnMessenger',
            roster: 'MijnRooster',
            treatment: 'Stimulerende/belemmerende factoren',
            treatment_detail_page: 'Stimulerende/belemmerende factoren en/of notities voor het getuigschrift',
            lvs: 'Analyse',
            plan: 'Plan',
            worksheet: 'Mijn Werkblad (BETA Versie)',
            subtitle: {
                content: 'leerkracht',
                template: 'leerling',
                files: 'leerkracht',
                messenger: 'leerkracht',
                worksheet: 'leerkracht',
            },
        },
    },
    'schedule': {
        title: 'Schema | Schema\'s',
        subject: 'Schema onderwerp',
        overview: 'Doelen overzicht',
    },
    'roles': {
        'user': 'MijnGebruikers | MijnGebruikers',
        'child': 'Kind | Kinderen',
        'student': 'Leerling | Leerlingen',
        'guardian': 'Ouder | Ouders',
        'teacher': 'Leraar | Leraren',
        'specialist': 'Roostermaker | Roostermakers',
        'supervisor': 'IB\'er | IB\'ers',
        'reseller': 'Reseller | Resellers',
        'administrator': 'Beheerder | Beheerders',
        'root': 'Super Beheerder | Super Beheerders',
        'board-member': 'Roostermaker | Roostermakers',
    },
    'teacher': {
        add: 'Voeg leraar toe | Voeg leraren toe',
        subject: {
            title: 'Hoofdgebieden van deze leraar',
            dialog: {
                select: {
                    title: 'Alle hoofdgebieden',
                    subTitle: 'Kies het hoofdgebied(en) die door de leraar gegeven wordt',
                },
                confirm: {
                    title: 'Klopt dit?',
                    subTitle: 'Zijn dit de standaard hoofdgebieden die door deze leraar gegeven worden?',
                },
                finished: {
                    title: 'Klaar!',
                    subTitle: 'De hoofdgebieden zijn aan de leraar gekoppeld',
                },
            },
            noSubjects: 'Geen specifieke hoofdgebieden gevonden',
        },
    },
    'student': {
        add: 'Leerling toevoegen | Leerlingen toevoegen',
        redo_level: 'Afwijkende niveaus niet aanpassen',
        scoolfolio: 'Leerlingprofiel',
        area: 'Hoofddoel',
        portfolio_archive: 'Getuigschrift archief',
        archive: {
            download_to_archive: 'Download getuigschrift naar archief',
            download_to_local: 'Download getuigschrift naar computer',
        },
    },
    'table': {
        found: '{total} {name} gevonden',
        perPage: '{name} per pagina:',
        noData: 'Geen gegevens beschikbaar',
        noStep: 'Geen stappen beschikbaar',
        maxCapacity: 'Maximum capaciteit',
        type: 'Type',
    },
    'errors': {
        loading: {
            description: 'Er is een probleem opgetreden bij het laden van de vereiste informatie.',
            suggestion: 'Probeer het later opnieuw of maak via de Helpdesk een ticket aan.',
        },
        notFound: {
            description: 'De door jouw opgevraagde pagina is niet gevonden.',
            suggestion: '404',
            url: 'Controleer de URL voor eventuele typefouten',
            error: '404 ERROR.',
            oops: 'Oeps :(',
            noSchool: 'De school die je probeert te bereiken bestaat niet.',
            or: 'of',
            contact: 'Neem contact met ons op via',
            signUp: 'om je te aanmelden bij MijnLeerlijn!',
        },
    },
    'idp': {
        title: 'MijnPLP',
        titleShort: 'MijnPLP',
        completedTotal: 'Je hebt {completed} van de {total} leerdoelen behaald',
        add: 'PLP toevoegen',
        add_skill_set: 'Vaardighedenset toevoegen',
        current: 'Huidig PLP',
        future: 'Komend PLP',
        dismissed: 'Niet van toepassing',
        active: 'Actief',
        project: 'Project',
        expandTopic: 'Open',
        collapseTopic: 'Dicht',
        filter: 'Filter',
        generate: {
            title: 'Genereer PLP',
            titleWithName: 'Genereer PLP van {name}',
            message: 'Klik op de knop om (aanpassingen in) huidig/komend PLP te genereren.',
            attention: '* Let op, hiermee wordt ook het huidige PLP geüpdatet',
            warning: 'Dit kan 5 minuten duren voordat het bij alle leerlingen zichtbaar is.',
            button: 'Genereren',
        },
        synchronize: {
            title: 'Synchroniseer periodeplannen',
            message: 'Klik op de knop om (aanpassingen in) huidig/komende periodeplannen te synchroniseren.',
            warning: 'Dit kan 5 minuten duren voordat het bij alle leerlingen zichtbaar is.',
            button: 'Synchroniseren',
        },
        delete: {
            title: 'Leerdoelen verwijderen van Persoonlijk LeerdoelenPlan (PLP)',
            message: 'Via onderstaande acties worden leerdoelen met de gekozen status van alle PLP\'s verwijderd.',
            warning: 'Verwerkingstijd max. 5 minuten.',
            button: 'Leerdoelen status {status}',
        },
        reset: {
            warning: 'Dit kan tot 30 minuten duren.',
        },
        status: {
            busyHighlightedOld: 'Huidig, Mee bezig & Oud',
            highlighted: '{highlighted} | Mee bezig',
            busy: '{busy} | Huidig',
            old: '{old} | Oud',
            inactive: '{inactive} | Inactief',
            closed: '{closed} | Gesloten',
            finished: '{finished} | Behaald',
            future: '{future} | Komend',
            dismissed: '{dismissed} | N.v.t.',
        },
        treatment: {
            purple: '{purple} | n.t.b',
            teal: '{teal} | n.t.b',
            blue: '{blue} | n.t.b',
            yellow: '{yellow} | n.t.b',
            burgundy: '{burgundy} | n.t.b',
            pink: '{pink} | n.t.b',
        },
        errors: {
            noGoals: {
                description: 'Je huidige Persoonlijk LeerdoelenPlan bevat nog geen doelen.',
                suggestion: 'Voeg een paar leerdoelen toe of maak een andere selectie.',
            },
        },
    },
    'progress': {
        title: 'Dit ben ik / Vaardigheden',
        placeholder: 'Voeg hier je eigen tekst...',
        label: {
            title: 'label | labels',
            header: 'Dit ben jij',
            new: 'Nieuw label',
        },
        interest: {
            title: 'interesse | interesses',
            header: 'Dit ben ik',
            new: 'Nieuw interesse',
        },
        photoalbum: {
            title: 'foto | foto\'s',
            header: 'Foto album',
        },
        skill: {
            title: 'vaardigheid | vaardigheden',
            header: 'Vaardigheden',
            goals: 'Leerdoelen',
            new: 'Nieuwe vaardigheid',
            general: 'Persoonlijk',
        },
        result: {
            title: 'bestand | bestanden',
            header: 'Bestanden',
            table: {
                header: {
                    name: 'Naam',
                    description: 'Omschrijving',
                },
            },
        },
        dialog: {
            title: 'Updaten',
            subtitle: 'Weet je zeker dat je {item} wilt updaten?',
            uploadFile: 'Upload bestand',
            selectFile: 'Selecteer bestand',
            selected: 'gekozen',
        },
        button: {
            add: 'Voeg {item} toe',
        },
    },
    'portfolio': {
        title: 'MijnDrive',
        no_result: 'Geen bestanden gevonden',
        select: {
            area: 'Kies hoofdgebied',
            topic: 'Kies deelgebied',
        },
        dialog: {
            scoolPlan: 'sCoolPlan',
            title: 'Upload in MijnDrive',
            addGoal: 'Upload een bestand bij een leerdoel',
            addGoalDescription: 'Getuigschrift leerling',
            addOther: 'sCoolPlan: Upload informatie over de leerling',
            addOtherDescription: 'Dossier (alleen zichtbaar voor leerkrachten)',
            placeholder: {
                description: 'Omschrijving',
            },
            message: 'Je kunt bestanden tot 250MB uploaden',
            fileSizeExceededTitle: 'Bestand te groot.',
            fileSizeExceededMessage: 'Het bestand dat je probeert te uploaden is groter dan 250MB, probeer het bestand te verkleinen en upload het opnieuw.',
        },
        skills: {
            noValidCategories: 'Alle vaardigheden zijn toegevoegd aan het getuigschrift van deze student. U kunt een extra vaardighedenset maken op de pagina met vaardighedensets.',
            textSkillSets: 'Vaardigheden',
        },
        showOther: 'MijnPlan bestanden',
        document: 'Plan',
    },
    'actions': {
        notObligate: 'Niet verplichten',
        obligate: 'Wel verplichten',
        delete: 'Verwijder | Verwijderd',
        add: 'Voeg toe | Toegevoegd',
        edit: 'Pas aan | Aangepast',
        cancel: 'Stop | Gestopt',
        save: 'Opslaan | Opgeslagen',
        back: 'Terug',
        next: 'Volgende',
        close: 'Dicht',
        markAsSaved: 'Markeer als opgeslagen',
        markAsAchieved: 'Behaald',
        markAsNotAchieved: 'Niet behaald',
        markAsFinished: 'Klaar',
        markAsNotFinished: 'Niet klaar',
        needHelp: 'Hulp nodig',
        dontNeedHelp: 'Geen hulp nodig',
        assisted: 'Leerling geholpen',
        markAsBusy: 'Markeer als bezig',
        addAttachment: 'Voeg bijlage toe',
        send: 'Zoek',
        download: 'Download',
        upload: 'Upload',
        ok: 'Ok',
        reset: 'Reset',
        saveAndUpload: 'Opslaan en uploaden',
        getTotal: 'Aantallen inzien',
    },
    'chat': {
        title: 'Chat | Chats',
        subject: 'Doel | Doelen',
        message: 'MijnBerichten',
        attendees: 'Deelnemers',
        messageTo: 'Type hier je bericht (Zitten de juiste gebruikers in het gesprek?) ...',
        send: 'Verzenden',
        add: 'Gebruiker toevoegen',
        files: 'Bestanden',
        deleted: 'Dit bericht is verwijderd',
        regarding: 'Chat omtrent',
        group: {
            title: 'Klas | Klassen',
            studentGuardian: 'Leerling, Ouder(s) en Leraren',
            guardiansOnly: 'Ouder(s) en Leraren',
            teachersOnly: 'Alleen met Leraren (Intern)',
        },
    },
    'levels': {
        all: 'Alle Niveaus',
        download: {
            button: 'Download rapport',
            title: 'Rapport downloaden',
            description: 'Het rapport wordt momenteel klaargemaakt…',
        },
        toggleActive: 'Toon alleen actieve deelgebieden',
        add: '{item} toevoegen',
        topics: 'deelgebieden',
        grade: 'Niveau',
        changeGrade: 'Wijzig niveau',
        room: 'Lokaal',
        dialog: {
            title: 'Aanpassen',
        },
    },
    'projects': {
        navigation: {
            title: 'MijnPeriodeplannen',
            all: 'Alle periodeplannen',
            mine: 'Mijn periodeplannen',
        },
        table: {
            name: 'Naam',
            description: 'Omschrijving',
            subjects: 'Leerdoelen',
        },
        tabs: {
            subjects: 'Leerdoelenoverzicht',
            media: 'Media',
            notes: 'Inhoud',
            project_plan: 'Periode algemeen',
            files: 'Bestanden',
            messenger: 'MijnBerichten',
        },
        dialog: {
            steps: {
                info: 'Project informatie',
                subjects: 'Leerdoelen',
                subjects_confirm: 'Leerdoelen bevestigen',
            },
            info: {
                title: 'Maak een nieuw periodeplan',
                name: 'Naam',
                description: 'Uitleg',
            },
            subjects: {
                title: 'Leerdoelen toevoegen',
            },
            subjects_confirm: {
                title: 'Leerdoelen bevestigen',
            },
            create: 'Periodeplan aanmaken',
        },
        select: {
            placeholder: 'Selecteer een periodeplan',
        },
        description: 'Uitleg',
        title: 'Periodeplan',
        all: 'Alle periodeplannen',
        mine: 'Mijn periodeplannen',
        add: '{item} toevoegen',
        no_project_alert_text: 'Je bent nogniet gekoppeld aan een periodeplan.',
        no_project_alert_subtext: 'Go to the profile page to link it.',
    },
    'student_plan': {
        template: {
            title_placeholder: 'Alinea titel',
            title_label: 'Titel',
            name_placeholder: 'Sjabloon naam',
            name_label: 'Naam',
            add_step: 'Alinea toevoegen',
            add_lvs: 'Opmerking getuigschrift toevoegen',
            add_subjects: 'Uit PLP toevoegen',
            select: 'Kies een sjabloon (optioneel)',
            quill: 'Schrijf hier de inhoud van de alinea',
            all: 'Alle Sjablonen',
            create: 'Maak sjabloon',
            cancel: 'Annuleren',
            title: 'Sjabloon | Sjablonen',
            sidebar: 'Sjablonen',
        },
        table: {
            title: 'Titel',
            description: 'Omschrijving',
            start_at: 'Start Datum',
            end_at: 'Eind Datum',
            status: 'Status',
        },
        dialog: {
            steps: {
                one: 'Basis Informatie',
                two: 'Inhoud',
                three: 'Bestanden',
                teachers: 'Teachers',
            },
            one: {
                title: 'Maak nieuw periode voorbereiding | Bewerk het periode voorbereiding',
                name: 'Naam',
                description: 'Uitleg',
                quill: 'Geef uitleg over deze periode voorbereiding',
            },
            two: {
                title: 'Periode voorbereiding',
            },
            three: {
                title: 'Periode voorbereiding bijlage(n)',
            },
            one_student: {
                title: 'Maak nieuw document | Bewerk het document',
                name: 'Naam',
                description: 'Uitleg',
                quill: 'Geef uitleg over deze getuigschrift',
            },
            two_student: {
                title: 'Document',
            },
            three_student: {
                title: 'Getuigschrift bijlage(n)',
            },
            save: 'Document opslaan | Document opslaan',
            start_date: 'Selecteer start datum',
            end_date: 'Selecteer eind datum',
            plan_status: 'Kies een status',
            is_visible_to_parents: 'Delen met ouders/verzorgers',
            is_visible_for_teachers: 'Delen met alle leraren',
            select_teachers: 'Delen met leraren:',
            create: 'Maak sjabloon',
        },
        school_settings: {
            status_title: 'Document statussen',
            dialog: {
                status_label: 'Status',
                status_placeholder: 'Status',
                title: 'Nieuwe Status',
                create: 'Aanmaken',
            },
        },
        description: 'Omschrijving',
        title_group: 'Periode voorbereiding | Periode voorbereidingen',
        title: 'Document | Documenten',
        all: 'Alle leerling documenten',
        add: 'Periode voorbereiding toevoegen',
        add_student: 'document toevoegen',
    },
    'template': {
        placeholder: 'Stappen tekst',
    },
    'help': {
        title: 'Klantenservice',
    },
    'facts': {
        title: 'MijnFacts',
    },
    'starts': {
        title: 'Begin datum',
    },
    'stats': {
        title: 'MijnStats',
    },
    'feature': {
        title: 'New Features',
    },
    'absence': {
        title: 'Symbioseregeling',
        text: 'Voor scholen die voor de symbioseregeling administratie moeten bijhouden, kan je hier een uitdraai maken.',
        download: 'Wanneer je gebruik maakt van de Symbioseregeling, Download hier de statistieken',
    },
    'reset': {
        title: 'Reset kwartalen en niveaus',
        levels: {
            title: 'niveaus',
            text: 'Klik op de knop om alle afwijkende niveaus voor alle deelgebieden en alle leerlingen terug te zetten naar het hoofdniveau',
        },
        periods: {
            title: 'kwartalen',
            text: 'Klik op de knop om alle afwijkende kwartalen voor alle leerlingen terug te zetten naar de huidige standaard periode',
        },
    },
    'ends': {
        title: 'Eind datum',
    },
    'value': {
        title: 'Excel',
    },
    'sequence': {
        title: 'Sorteer',
    },
    'address': {
        country: 'Land',
        placeholder: 'Selecteer Land',
    },
    'language': {
        placeholder: 'Selecteer taal',
    },
    'userImportErrors': {
        101: 'Een kleuterklas bestaat niet',
        102: 'Een klas bestaat niet',
        201: 'Sommige verplichte excel velden zijn leeg',
        1000: 'Er is iets mis gegaan',
    },
    'component': {
        selectFilter: {
            placeholder: 'Kies',
            level: 'Niveau',
            subject_label: 'tags',
            period: 'Kwartaal',
            block: 'Blok',
            group: 'Klas',
        },
    },
    'downloadDialog': {
        header: {
            title: 'Download leerdoelenboekje',
            description: 'Selecteer hoofdgebieden voor in het boekje en download de pdf.',
        },
        select: {
            label: 'Selecteer leerdoelen',
        },
    },
    'removeDialog': {
        header: {
            title: 'Verwijder leerdoelen uit PLP',
            description: 'Selecteer de hoofdgebieden die je wilt verwijderen.',
        },
        button: {
            select: 'Selecteer alle leerdoelen',
            removeAll: 'Verwijder allen',
            removeInProgress: 'Verwijder mee bezig',
            removeNew: 'Verwijder nieuw',
            removeOld: 'Verwijder oud',
        },
        successMessage: 'De geselecteerde leerdoelplannen zijn verwijderd.'
    },
    'createDialog': {
        header: {
            choose: 'Kies',
            import: 'Importeer',
            export: 'Exporteer',
            profile: 'Profiel',
            relationship: 'Relatie',
            confirm: 'Bevestig',
            finished: 'Klaar',
            explore: 'Leerlingen toevoegen',
            create: 'Klas informatie',
            address: 'Adres',
            select: 'Kies',
            merge: 'Klas toevoegen',
        },
        choose: {
            title: 'Maak een {role} aan',
            text: 'Maak een {role} aan via een excel of los',
            options: {
                one: {
                    title: 'Upload .xsl bestand',
                    text: 'Voor één of meer {role}',
                },
                two: {
                    title: 'Maak een {role} profiel aan',
                    text: 'Voor één {role}',
                },
            },
        },
        profile: {
            title: 'Maak een {role} aan',
            text: 'Maak een nieuwe aan',
            upload: 'Upload een foto',
            click: 'Klik hier',
        },
        import: {
            title: 'Importeer {role}',
            text: 'Upload een Excel bestand',
            browse: 'Klik om een bestand te uploaden voor een {role}',
        },
        relationship: {
            title: 'Ouders',
            text: 'Kies een bestaande {role} of maak een nieuwe aan.',
            existing: 'Kies een bestaande {role}',
            create: 'Maak een nieuw {role} profiel aan',
            chosen: 'Gekozen {role}',
            or: 'of',
            save: 'Opslaan {role}',
            placeholder: 'Kies {role}',
        },
        confirm: {
            title: 'Bevestig de gegevens',
            text: 'Bevestig of alle informatie juist is voor de nieuwe {role}.',
            selected: 'Geselecteerde',
        },
        select: {
            curriculum: {
                title: 'Lopend Curriculum',
                text: 'Kies leerdoelen om toe te voegen aan het PLP.',
                confirmTitle: 'Bevestig de leerdoelen voor het PLP',
                confirmText: 'Wil je deze leedoelen aan het PLP toevoegen?',
                idpType: 'Aan welk PLP wil je deze leerdoelen toevoegen?',
                created: 'Je hebt nieuwe leerdoelen aan het PLP toegevoegd',
            },
        },
        finished: {
            title: 'Gelukt!',
            text: 'Je hebt een nieuwe {role} aangemaakt',
            password: 'De nieuwe gebruiker kan inloggen met dit wachtwoord:',
            imported: {
                part1: 'Je hebt geimporteerd',
                part2: 'nieuwe {role}.',
            },
            updated: '{role} is geupdate.',
            failed: {
                title: 'Deels gelukt',
                row: 'Rij',
                email: 'Email',
                field: 'Veld',
                missing_email: 'Onbekend',
                explainer: 'Het betreft de volgende',
                errors: {
                    email: 'Email',
                    dob: 'Geboortedatum',
                    first_name: 'Voornaam',
                    last_name: 'Achternaam',
                },
                part1: 'We konden niet uploaden',
                part2: '{role}',
            },
        },
        create: {
            title: 'Maak een nieuwe {role} aan',
            text: 'Koppel gebruikers aan een {role}.',
            type: 'Type | Types',
            placeholder: 'Selecteer {role} type',
        },
        explore: {
            title: 'Leerlingen toevoegen',
            text: 'Bekijk de gegeven en bevestig voor een {role}.',
        },
        merge: {
            title: 'Klas toevoegen',
            text: 'Leerlingen uit deze klassen worden automatisch in je nieuwe klas geplaatst.',
        },
    },
    'dialogOptions': {
        item: {
            user: 'gebruiker',
            student: 'leerling',
            students: 'leerlingen',
            progress: 'Voortgang',
            teacher: 'leraar',
            guardian: 'ouder',
            area: 'hoofdgebied',
            message: 'bericht',
            subject: 'leerdoel',
            subjects: 'leerdoelen',
            treatment: 'opmerkingen voor getuigschrift',
            topic: 'deelgebied',
            curriculum: 'curriculum',
            group: 'klas',
            level: 'niveau',
            period: 'kwartaal',
            file: 'bestand',
            template: 'week sjabloon',
            step: 'stap',
            year: 'jaar',
            tag: 'school',
            school: 'klant',
            note: 'notitie',
            room: 'lokaal',
            lessonType: 'les type',
            lesson: 'les',
            activity: 'les',
            timeslot: 'tijdslot',
            project: 'project',
            helpAndFinished: 'hulp en afgerond status',
            plan: 'plan',
        },
        success: 'Success!',
        confirmation: 'Bevestiging',
        forbidden: 'Geen toegang',
        reset: 'Weet je zeker dat je {item} wilt resetten?',
        delete: 'Weet je zeker dat je dit {item} wilt verwijderen? | Weet je zeker dat je deze {item} wilt verwijderen?',
        deletePermanently: 'Weet je zeker dat je deze {item} definitief wil verwijderen?',
        deleteMany: 'Weet je zeker dat je deze {item} wilt verwijderen?',
        deleteMultiple: 'Weet je zeker dat je {amount} {item} wilt verwijderen?',
        deleteFromGroup: 'Weet je zeker dat je deze {item} uit de klas wil verwijderen?',
        notObligate: 'Weet je zeker dat je {item} niet wil verplichten voor deze les? | Weet je zeker dat je deze {item} niet wil verplichten voor deze les?',
        obligate: 'Weet je zeker dat je {item} wil verplichten voor deze les? | Weet je zeker dat je deze {item} wil verplichten voor deze les?',
        resetPeriods: 'Let op! Je gaat alle afwijkende kwartalen terugzetten naar de basis. Deze actie is niet ongedaan te maken!',
        resetLevels: 'Let op! Je gaat voor elke alle afwijkende niveaus terugzetten naar het hoofdniveau. Deze actie is niet ongedaan te maken!',
        sync_warning: 'Let Op! Weet u zeker dat u wilt synchroniseren met parnassys. Deze actie kan niet ongedaan gemaakt worden!',
        sync_warning_goals_sets: 'Let Op! Weet u zeker dat u de periodeplannen wilt synchroniseren? Deze actie kan niet ongedaan gemaakt worden!',
        init_warning: 'Weet je zeker dat je parnassys wilt initialiseren?',
        lesson: 'Weet je zeker dat je deze {item} wilt kiezen?',
        save: '{item} is opgeslagen',
        update: 'Weet je zeker dat je dit {item} wilt update? | Weet je zeker dat je deze {item} wilt updaten?',
        export: 'Weet je zeker dat je dit {item} wilt exporteren? | Weet je zeker dat je deze {item} wilt exporteren?',
        button: {
            delete: 'Verwijder',
            cancel: 'Nee dat wil ik niet',
            ok: 'Oke',
            reset: 'Resetten',
            yes: 'Ja',
        },
        switchedVersion: 'De school is veranderd naar versie {version}. Om de wijzigen toe te passen moet de pagina herladen worden',
        deleteBusyPLP: 'Let op! Deze actie verwijdert alle doelen met de status huidig, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Oude en uitgelichte doelen blijven in het PLP staan. Deze actie is onomkeerbaar.',
        deleteHighlightedPLP: 'Let op! Deze actie verwijdert alle doelen met de status uitgelicht, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Oude en huidige doelen blijven in het PLP staan. Deze actie is onomkeerbaar.',
        deleteOldPLP: 'Let op! Deze actie verwijdert alle doelen met de status oud, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Uitgelichte en huidige doelen blijven in het PLP staan. Deze actie is onomkeerbaar.',
        deleteCurrentPLP: 'Let op! Deze actie verwijdert de huidige PLP\'s van leerlingen. Alle doelen, inclusief huidige, oude en uitgelichte doelen, worden verwijderd, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Deze actie is onomkeerbaar.',
        deleteFuturePLP: 'Let op! Deze actie verwijdert komende PLP\'s van leerlingen. Alle doelen in een komend PLP worden verwijderd, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Deze actie is onomkeerbaar.',
    },
    'swapDialog': {
        title: 'Wissel deelgebied',
        topic: 'Naam deelgebied',
        select: {
            area: 'Selecteer Hoofdgebied',
            topic: 'Selecteer Deelgebied',
        },
        placeholder: 'Kies een',
        swap: 'Wissel',
    },
    'importSubjects': {
        title: 'Importeer Hoofdgebied, Deelgebied en/of Leerdoelen',
        text: 'Importeer Hoofdgebied, Deelgebied en/of Leerdoelen uit een excel.',
    },
    'lvs': {
        title: 'Analyse instellingen',
        text: 'Selecteer het gewenste analysemoment (midden of einde) en de klas. Klik vervolgens op \'genereren\' om de analyse te starten. Let op! Bij het kiezen van eenzelfde klas en analysemoment wordt de eerder gegenereerde analyse overschreven.',
        textwarning: 'Het genereren van de analyse kan tot 30 minuten duren.',
        select: {
            placeholder: 'Selecteer een toets',
            group_placeholder: 'Selecteer een klas',
            middle: 'Midden',
            end: 'Einde',
            start: 'Begin',
        },
        dialog: {
            confirm: {
                text: 'Weet u zeker dat u de analyse van geselecteerde klas wilt genereren? Let op! Bij het kiezen van eenzelfde klas en analysemoment wordt de eerder gegenereerde analyse overschreven.',
            },
            success: {
                text: 'Analyse van studenten wordt momenteel gegenereerd. Dit kan tot 30 minuten duren.',
            },
        },
        action: {
            run: 'Genereren',
        },
        treatment: {
            title: 'Opmerkingen voor getuigschrift per hoofdgebied',
            area: 'Hoofdgebied',
            description: 'Notitie(s) / analyse:',
        },
    },
    'snackbar': {
        actions: {
            chat: 'Chat',
            roadmap: 'Stappenplan',
            deselect: 'Deselecteren',
            reset_statuses: 'Reset status',
        },
    },
    'summary': {
        title: 'Leerdoelen Overzicht',
        clearStudentStatuses: 'Reset hulp en afgerond status',
        status: 'Verander status leerdoel',
        description: 'Stappenplan',
        message: 'Chat bericht over leerdoel',
        placeholder: 'Acties:',
        view: 'Notitie over leerling',
        open: 'Naar profiel',
        error: 'De gekozen selectie bevat geen leerlingen.',
        treatmentAdd: 'Voeg opmerkingen voor getuigschrift toe',
        patience: 'Een moment a.u.b..',
        support: 'Probeer het nog een keer of neem contact op met de Helpdesk.',
        dialog: {
            status: {
                title: 'Verander status leerdoel(en)',
                text: 'Verander status voor {length} leerdoelen',
                takingTooLong: 'We zijn bezig om de aanpassingen uit te voeren.',
                alert: {
                    failed: {
                        title: 'We zijn nog steeds bezig met de aanpassingen, vermoedelijk is er iets mis gegaan.',
                    },
                    submitted: {
                        title: 'Status leerdoel is voor {length} leerdoelen aangepast.',
                    },
                },
            },
            statusFinalized: {
                title: 'Verander beoordeling leerdoel(en)',
                text: 'Verander beoordeling voor {length} leerdoelen',
                takingTooLong: 'We zijn bezig om de aanpassingen uit te voeren.',
                alert: {
                    failed: {
                        title: 'We zijn nog steeds bezig met de aanpassingen, vermoedelijk is er iets mis gegaan.',
                    },
                    submitted: {
                        title: 'Beoordeling leerdoel is voor {length} leerdoelen aangepast.',
                    },
                },
            },
            message: {
                title: 'Laat een chat bericht achter',
                text: 'Laat een bericht achter bij de geselecteerde leerlingen die dit doel hebben uitgelicht. Je plaatst hetzelfde bericht bij elke leerling maar ze kunnen niet als groep reageren .',
                placeholder: 'Bericht',
                takingTooLong: 'We zijn bezig het bericht te plaatsen.',
                send: 'Verstuur',
                alert: {
                    failed: {
                        title: 'We zijn nog steeds bezig met het sturen van je bericht, vermoedelijk is er iets mis gegaan.',
                    },
                    notSelected: {
                        title: 'Één of meerdere van deze doelen heeft geen gele status, dus werkt Mijnberichten niet.',
                        text: 'Pas deze doelen aan naar een gele status om een chatbericht te versturen.',
                    },
                    submitted: 'Er zijn {length} nieuwe berichten geplaatst.',
                },
            },
            description: {
                title: 'Nieuwe stap doorgeven',
                text: 'Kies rechts via de drie puntjes een voorgekozen stap en schrijf een nieuwe voor {length} leerdoel(en)',
                header: 'Stappen',
                takingTooLong: 'Wij zijn bezig met het aanpassen van de volgende stap.',
                placeholder: 'Leg uit wat de volgende stap is.',
                alert: {
                    failed: 'Het aanpassen van de volgende stap duurt wat langer dan normaal. Er is mogelijk iets fout gegaan.',
                    submitted: 'De volgende stap is aangepast voor {length} leerdoel(en).',
                },
            },
        },
    },
    'steps': {
        title: 'Stap | Stappen',
        placeholder: 'Stappen tekst',
    },
    'select_filter': {
        monday: 'maandag',
        tuesday: 'dinsdag',
        wednesday: 'woensdag',
        thursday: 'donderdag',
        friday: 'vrijdag',
        saturday: 'zaterdag',
        sunday: 'zondag',
    },
    'rosterAudits': {
        activity: {
            missing: 'Dit tijdslot heeft nog geen activiteiten.',
        },
        event: {
            missing: 'Deze datumtijdslot heeft nog geen lessen.',
        },
        teacher: {
            absent: '{name} is niet aanwezig voor dit tijdslot.',
            contract: 'Dit tijdslot vindt plaats buiten de contracturen van {name} op {day}.',
            occupied: '{name} is al ingepland voor iets anders op dit tijdslot.',
            vacation: '{name} is niet beschikbaar omdat er vrijgenomen is.',
        },
        group: {
            occupied: 'De klas "{name}" is gekoppeld aan meerdere activiteiten.',
            unassigned: 'Klas "{name}" is nog nergens aan gekoppeld.',
            missing: 'Er zijn nog geen klassen uitgenodigd naar een activiteit.',
            recess: 'Klas "{name}" is ingepland voor een pauze en les tegelijketijd.',
        },
        room: {
            occupied: 'Het lokaal "{name}" is gekoppeld aan meerdere activiteiten.',
        },
        level: {
            occupied: 'Het niveau "{name}" is gekoppeld aan meerdere activiteiten.',
            unassigned: 'Niveau "{name}" is nog nergens aan gekoppeld.',
            missing: 'Er zijn nog geen niveaus uitgenodigd naar een activiteit.',
            recess: 'Niveau "{name}" is ingepland voor een pauze en les tegelijketijd.',
        },
    },
    'logs': {
        title: 'Logs',
        fetch: 'Logs ophalen',
    },
    'yes': 'Ja',
    'no': 'Nee',
    'by': 'door',
    'on': 'op',
    'quillEditor': {
        placeholder: 'Voeg hier je tekst in ...',
    },
    'date': {
        title: 'Datum',
    },
    'finished': {
        comment: 'Omschrijving',
        by_teacher: 'Door',
        finished_on: 'op',
    },
    'uploadNoteDialog': {
        header: 'Upload notitie naar MijnDrive',
        placeholder: 'Titel beschrijving',
    },
    'settings': {
        student: 'Leerling instellingen',
        guardian: 'Ouder instellingen',
        has_roster: {
            title: 'Autoplanner e-mail versturen bij leeg rooster',
            description: 'Verstuur de autoplanner e-mail bij een leeg rooster',
        },
        plp: {
            title: 'Doel op geel zetten',
            description: 'Leerlingen kunnen zelf in het PLP het doel op geel zetten',
        },
        guardian_can_see_student_scooltracker: {
            title: 'Bepalen of je de MijnPLP tab voor ouders uit zet',
            description: 'Ouders kunnen de MijnPLP tab zien',
        },
        guardian_can_see_student_this_is_me: {
            title: 'Bepalen of je de Dit Ben Ik tab voor ouders uit zet',
            description: 'Ouders kunnen de Dit Ben Ik tab zien',
        },
        guardian_can_see_student_portfolio: {
            title: 'Bepalen of je de MijnDrive tab voor ouders uit zet',
            description: 'Ouders kunnen de MijnDrive tab zien',
        },
        guardian_can_see_student_finished: {
            title: 'Bepalen of je de Successen tab voor ouders uit zet',
            description: 'Ouders kunnen de Successen tab zien',
        },
        guardian_can_see_student_profile: {
            title: 'Bepalen of je de Profiel tab voor ouders uit zet',
            description: 'Ouders kunnen de Profiel tab zien',
        },
        guardian_can_see_student_notes: {
            title: 'Bepalen of je de Notities tab voor ouders uit zet',
            description: 'Ouders kunnen de Notities tab zien',
        },
        guardian_can_see_student_roster: {
            title: 'Bepalen of je de MijnRooster tab voor ouders uit zet',
            description: 'Ouders kunnen de MijnRooster tab zien',
        },
        guardian_can_use_chat_functions: {
            title: 'Bepalen of je de chat functie voor ouders uit zet',
            description: 'Ouders kunnen de chat functies gebruiken bij PLP en bij de MijnBerichten van een leerling',
        },
        guardian_can_see_student_lvs: {
            title: 'Bepalen of je de Analyse tab bij een leerling laat zien voor ouders',
            description: 'Ouder kunnen de Analyse tab zien van een leerling',
        },
        hide_my_roster: {
            title: 'Digitale Klassenmap',
            description: 'Zet deze optie aan om de Digitale Klassenmap te activeren. Onderdeel MijnRooster zal dan niet meer zichtbaar zijn voor leraren en leerlingen.',
        },
        parnassys: {
            brin_number_title: 'Brinnummer',
            brin_number_subtitle: 'Vul hier het brinnummer in van de school',
            guardians_title: 'Synchroniseer ouders',
            guardians_subtitle: 'Als deze instelling aan staat, zullen ouders worden gesynchroniseerd vanuit Parnassys naar in Mijn Leerlijn.',
            teachers_title: 'Synchroniseer leerkrachten',
            teachers_subtitle: 'Als deze instelling aan staat, zullen leerkrachten worden gesynchroniseerd vanuit Parnassys in Mijn Leerlijn.',
            automatic_sync_students_title: 'Automatische synchronisatie studenten',
            automatic_sync_students_subtitle: 'Als deze optie is ingeschakeld, worden studenten elke dag om 07:00 uur automatisch gesynchroniseerd',
            automatic_sync_teachers_title: 'Automatische synchronisatie leraren',
            automatic_sync_teachers_subtitle: 'Als deze optie is ingeschakeld, worden leraren elke dag om 07:00 uur automatisch gesynchroniseerd',
            automatic_sync_guardians_title: 'Automatische synchronisatie Ouders',
            automatic_sync_guardians_subtitle: 'Als deze optie is ingeschakeld, worden ourders elke dag automatisch om 07:00 uur gesynchroniseerd',
        },
        mfa: {
            teachers_title: 'MFA leerkrachten',
            teachers_subtitle: 'Als deze instelling aan staat, zullen leerkrachten moeten inloggen door middel van MFA.',
            students_title: 'MFA leerlingen',
            students_subtitle: 'Als deze instelling aan staat, zullen leerlingen moeten inloggen door middel van MFA',
            guardians_title: 'MFA ouders',
            guardians_subtitle: 'Als deze instelling aan staat, zullen ouders moeten inloggen door middel van MFA',
        },
        group: {
            is_visible_for_students: 'Zichtbaar voor leerlingen',
            new_group_type: 'Nieuwe klastype',
            delete_error: 'Kan klastype niet verwijderen',
        },
    },
    'idp_pdf_download': {
        no_students_found: 'Er is iets fout gegaan tijdens het ophalen van de leerlingen.',
        will_be_sent_by_email: 'De leerlingboekjes worden gegenereerd en per e-mail naar u opgestuurd zodra ze klaar zijn. Dit kan enkele minuten duren.',
        download_successful: 'Klik op de button om het leerlingboekje te openen in een nieuw tabblad',
    },
    'select': {
        project: {
            placeholder: 'Choose a project',
        },
    },
    'skill_set': {
        add: 'Vaardighedenset toevoegen',
        delete: 'Vaardighedenset verwijderen',
        create: 'Vaardighedenset maken',
        create_button: 'Aanmaken',
        edit: 'Vaardighedenset bewerken',
        title: 'Vaardigheden',
        edit_name: 'Voer de nieuwe vaardigheidssetnaam in',
        dialog: {
            select_placeholder: 'Selecteer Vaardigheden',
            select_label: 'Vaardigheden',
            delete_category_warning: 'Weet u zeker dat u deze vaardighedenset wilt verwijderen?',
        },
        alert: {
            text: 'Er zijn nog geen vaardigheden gemaakt.',
            subtext: 'Je kunt er een toevoegen door op de knop te drukken.',
            delete: 'Weet je zeker dat je dit wilt verwijderen?',
        },
        add_skill: 'Vaardigheid toevoegen',
        name_placeholder: 'Typ de naam van een vaardighedenset',
    },
    'subjectSelect': {
        areaText: 'Selecteer een gebied',
        topicText: 'Kies een onderwerp',
    },
    'parnassys': {
        navigation_title: 'Parnassys',
        table: {
            results_found: 'gebruiker | gebruikers',
            headers: {
                name: 'Naam',
                roles: 'Rollen',
                parnassys_id: 'Parnassys ID',
            },
        },
        dialog: {
            no_users_found: 'We hebben geen leerling kunnen vinden. Probeer het opnieuw.',
            step_1: {
                header: 'Gebruikersgegevens',
                title: 'Gebruiker die moet worden gekoppeld',
                subtitle: 'Voer de naam in van de gebruiker die u aan parnassys wilt koppelen',
                find: 'Gebruiker zoeken',
                label: 'Selecteer leerling',
                placeholder: 'Leerling',
            },
            step_2: {
                header: 'Gebruikersselectie',
                title: 'Gebruiker die moet worden gekoppeld',
                subtitle: 'Voer de naam in van de gebruiker die u aan parnassys wilt koppelen',
                success: 'Gebruiker is succesvol gekoppeld',
            },
        },
    },
    'legend': {
        title: 'Legenda',
        description: 'Er is voor deze leerling een stappenplan toegevoegd.',
        open: 'Open de pop-up van het leerdoel van deze leerling.',
        steps: 'De voortgangsbollen van de leerling.',
        project: 'Dit leerdoel is aan een project gekoppeld.',
        help: 'Deze leerling heeft om hulp gevraagd.',
        finished: 'De leerling geeft aan dat het leerdoel behaald is.',
        prio: 'Dit leerdoel heeft prioriteit.',
        descriptions: {
            busy: 'Leerdoel wordt in de huidge kwartaal aangeboden. De leerling heeft nog geen instructie gehad / is nog niet begonnen met leerdoel.',
            highlighted: 'Leerling is aan het werk met het leerdoel.',
            old: 'Leerdoel uit voorgaande kwartaal / niveau. Leerling heeft nog niet aan het leerdoel gewerkt. (Status wordt automatisch toegekend aan leerdoelen met de blauwe status.)',
            inactive: 'Het leerdoel is niet gekoppeld aan de leerling veelal door ander niveau, handmatig verwijdert van het Persoonlijk LeerdoelenPlan.',
            closed: 'Het leerdoel is niet behaald, maar het leerddoel wordt niet verder meer aangeboden.',
            finished: 'Het leerdoel is behaald.',
            future: 'Het leerdoel staat klaar voor de leering voor de volgende kwartaal.',
            dismissed: 'Het leerdoel is handmatig op Niet Van Toepassing gezet door de leerkracht.',
        },
    },
    'navigationCard': {
        student: {
            schoolTracker: 'Bekijk hier het Persoonlijke LeerdoelenPlan van de leerling',
            thisIsMe: 'Dit ben ik, Dit ben jij, beoordeel doelen op groei en schrijf een stukje over het afgelopen kwartaal',
            portfolio: 'Verzamel en bekijk hier de persoonlijke plannen',
            profile: 'Bekijk hier de persoonlijke informatie, wijzig het wachtwoord, zie welke ouders zijn gekoppeld en van welke klas(en) de leerling lid is',
            messages: 'Lees en stuur hier berichten tussen leerling, ouder(s) en leraren',
            notes: 'Maak hier notities over de leerling',
            treatment: 'Schrijf hier korte notities voor de stimulerende/belemmerende factoren en/of notities voor het getuigschrift',
            plan_group: 'Maak hier de voorbereiding van je periode. | Bekijk en maak hier getuigschrift',
            plan: 'Maak hier de voorbereiding van je periode. | Bekijk en maak hier documenten. Zoals handelingsplannen, oudergesprekken en getuigschriften',
            levels: 'Analyseer of het aanbod (PLP) overeenkomst met de resultaten (PLP en LVS)',
            finished: 'Bekijk hier het overzicht de behaalde leerdoelen',
            roster: 'Bekijk het actuele weekrooster of kies lessen voor het komende weekrooster',
        },
        group: {
            profile: 'Bekijk de klas, gekoppelde leerkrachten en leerlingen en koppel hier je periodeplan.',
            files: 'Stukje tekst over',
            steps: 'Stukje tekst over',
            messages: 'Lees en stuur berichten naar de leden van de klas.',
            notes: 'Lees en maak notities over de klas.',
            audit: 'Bekijk het logboek van de klas.',
            studentOverview: 'Bekijk het aantal statussen van de klas per leerling en zie hoe de voortgang is ten opzichte van de andere groepsleden.',
            curriculum: 'Bekijk het aantal actieve leerdoelen per hoofd- en deelgebied van de leerlingen in de klas. Genereer vervolgens een Leerdoelenoverzicht om acties uit te voeren.',
            projectPlan: 'Bekijk hier de omschrijving van het periodeplan.',
            report: 'Bekijk en voer de resultaten in van de LVS-toets om een analyse te maken op klassenniveau. Deze resultaten maken het ook mogelijk om voor de leerling een analyse te maken (optioneel).',
            titles: {
                profile: 'Klasprofiel',
                messages: 'Chat',
                notes: 'Notities',
                plan: 'Periode algemeen',
                studentOverview: 'Klas analyse',
                curriculum: 'Leerdoelenoverzicht',
                report: 'LVS analyse',
            },
        },
        project: {
            subjects: 'Voeg de leerdoelen toe vanuit het curriculum aan het periodeplan',
            notes: 'Beschrijf de inhoud van de periodeplan en/of geef informatie aan de leerkracht over de periodeplan.',
            projectPlan: 'Beschrijf de inhoud van het perioplan, deze inhoud is bij je klas te zien wanneer je dit periodeplan aan je klas koppelt.',
            media: 'Sla bestanden, documenten en media op die passen bij de periodeplan',
            files: 'Stukje tekst over',
            messenger: 'Communiceer met leerlingen en/of leerkrachten over de periodeplan.',
            titles: {
                messenger: 'Chat',
            },
        },
    },
    'worksheet': {
        title: 'Keuzeformulier aanmaken werkblad',
        newWorksheet: 'Nieuw werkblad',
        openWorksheet: 'Open werkblad',
        downloadWorksheet: 'Download werkblad',
        succesMessage: 'Het werkblad is succesvol gegenereerd.',
        sumOptions: 'Som opties',
        reviewOptions: 'Nakijk opties',
        addendum: 'Toelichting',
    },
    'app_offline_title': 'Applicatie niet bereikbaar',
    'app_offline_subtitle': 'De applicatie is op dit moment niet bereikbaar, probeer de pagina te herladen.',
    'app_offline_button_reload': 'Probeer opnieuw',
    'choose_area': 'Kies Gebied',
    'choose_topic': 'Kies Deelgebied',
    'status': 'Aantallen',
    'insights': 'Inzicht',
    'student_overview': 'Studentenoverzicht',
    'prioritise': 'MijnVoorrang',
    'deprioritise': 'Geen voorrang',
    'prioritised': 'MijnVoorrang',
    'no_schools_connected': 'Geen scholen gekoppeld',
    'admin_dashboard_description': 'Dit is het dashboard van het adminportaal van MijnLeerlijn. Hier kun je accounts en scholen beheren.',
    'access_to_all_schools': 'Toegang tot alle scholen',
    'parnassys_name': 'Parnassys naam',
    'reset_mfa': 'Reset 2FA code voor gebruiker',
    'is_primary': 'Is primair',
    'user_text': 'Gebruiker',
    'group_text': 'Klas',
    'student_text': 'Leerling',
    'Remove {item}': '{item} verwijderen',
    'Update Available': 'Update beschikbaar',
    'A new release has been made available.': 'Refresh de browser om geen gegevens veloren te laten gaan.',
    'Working with an old version may cause unexpected issues.': 'Het werken met een oude versie van de applicatie kan onverwachte problemen opleveren.',
    'Refresh Application': 'Refresh de browser',
    'hide notification': 'melding verbergen',
    'Manually Refresh': 'Handmatig verversen',
    'When done with your work please close this window; or, refresh the page by using CTRL + F5 on a Windows device or CMD + R on an iOS (Apple) device.': 'Als je klaar bent sluit dan het venster, of ververs zelf de pagina door CTRL + F5 te gebruiken op een Windows machine of CMD + R op aan iOS (Apple) machine.',
    'Close': 'Sluiten',
};
export default translation;
